<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p style="text-align: center;"><span dir="rtl">أهدي هذا الكتاب إلى عائلتي وإلى كل شخص دعمَني وشجَّعني على دخول هذا العالم الجميل..</span></p>
<p style="text-align: center;"><span dir="rtl">عالم الكتابة والخوض في متاهاته الكثيرة للوصول إلى الغاية المنشودة..</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?660fb9aa